// Configurazione centrale del sito: tutti i dati mancanti vanno compilati QUI
// prima della pubblicazione definitiva. Nessun placeholder è disperso in altri file.

export const SITE_NAME = "DN STUDIO TECNICO";
export const SITE_PAYOFF = "Il tuo studio tecnico, ovunque tu sia.";
export const SITE_DESCRIPTION =
  "Pratiche tecniche, catastali, immobiliari e professionali gestite in tutta Italia. Prima valutazione gratuita, risposta entro 24 ore.";

// URL ufficiale del sito (senza slash finale).
export const SITE_URL = "https://dn-studio-tecnico.pages.dev";

// Indirizzo email operativo dello studio (riceve le richieste, contatto visibile)
export const CONTACT_EMAIL = "dnstudiotecnico@libero.it";

// Dati identificativi e professionali del titolare. Vengono mostrati solo
// dove strettamente necessario (note legali, privacy) una volta compilati.
export const LEGAL = {
  titolare: "",
  piva: "",
  pec: "",
  collegio: "",
};
